'use strict';
import SessionManager from '../Manager/Session.manager';
import axios from 'axios'
import { CPUtils } from '../scripts/Utils';
import Global from '../scripts/Global';
import { sessionHeader } from '../scripts/api/main.api';
import FileApi from '@/scripts/api/file.api';

export class Post {
    constructor(data){
        this.post_date = new Date().toLocaleDateString(SessionManager.getLoggedInUser().chat_visuals.language)

        this.user_id = SessionManager.getLoggedInUser().user_id

        if(typeof data.post_id != 'undefined'){
            this.post_id = data.post_id
        }
        if(typeof data.user_id != 'undefined'){
            this.user_id = data.user_id
        }
        if(typeof data.channel_id != 'undefined'){
            this.channel_id = data.channel_id
        }
        if(typeof data.created_at != 'undefined'){
            this.created_at = data.created_at
            this.post_date = new Date(data.created_at * 1000).toLocaleDateString(SessionManager.getLoggedInUser().chat_visuals.language)
        }

        if(typeof data.origin  != 'undefined'){
            this.origin = data.origin
            this.previewResponse = null
        }

        if(typeof data.origin_parsed  != 'undefined'){
            this.origin_parsed = data.origin_parsed

            if(data.origin_parsed.length > 0){
                // let urlsArray = CPUtils.getAllUrls(data.origin_parsed);
                // urlsArray.forEach((URL, i) => {
                //     if(URL.trim().length > 0){
                //         const params = {'url' : URL}
                //         axios
                //         .post(Global.GetAPIURL()+'/posts/linkpreview', JSON.stringify(params), {headers : {"session_id": sessionHeader.headers.session_id}}).then(res => {
                //             if(res.data.result){
                //               if(res.data.image.length > 0){
                //                 this.previewResponse = res.data
                //                 if(window.atob(res.data.image).indexOf('xml') > -1)
                //                     this.previewResponse = null
                //               }
                //             }
                //         }).catch(err => {
                //             console.warn("err =>>" + err )
                //         })
                //     }
                // });

                // Just the first link is tryied to get a linkpreview
                let URL = CPUtils.getURL(data.origin_parsed)
                if(URL.trim().length > 0){
                    const params = {'url' : URL}
                    axios
                    .post(Global.GetAPIURL()+'/posts/linkpreview', JSON.stringify(params), {headers : {"session_id": sessionHeader.headers.session_id}}).then(res => {
                        if(res.data.result){
                          if(res.data.image.length > 0){
                            this.previewResponse = res.data
                            if(window.atob(res.data.image).indexOf('xml') > -1)
                                this.previewResponse = null
                          }
                        }
                    }).catch(err => {
                        console.warn("err =>>" + err )
                    })
                }
            }
        }

        if(typeof data.parsed_items  != 'undefined'){
            this.parsed_items = data.parsed_items;
            if (!_.isEmpty(this.parsed_items)) {
                for (let key in this.parsed_items) {
                    if (this.parsed_items[key].type == 'file') {
                        this.parsed_items[key].size ='';
                    }
                }
            }
        }

        if(typeof data.sqn  != 'undefined'){
            this.sqn = data.sqn
        }

        if(typeof data.not_viewed_user_ids != 'undefined'){
            this.not_viewed_user_ids = data.not_viewed_user_ids
        }

        if(typeof data.edited_at  != 'undefined'){
            this.edited_at = data.edited_at
        }

        if(typeof data.mentioned_users  != 'undefined'){
            this.mentioned_users = data.mentioned_users
        }

        if(typeof data.type  != 'undefined'){
            this.type = data.type
            if(data.type == 'delete_user'){
                if(typeof data.deleted_user_id  != 'undefined'){
                    this.deleted_user_id = data.deleted_user_id
                }

                if(typeof data.deleted_user_email  != 'undefined'){
                    this.deleted_user_email = data.deleted_user_email
                }
            }
        }
    }
}
